import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { formatComparativeUnitForPledge, ghgSolutionMetricAssignment, roundValue } from '~/functions/ghg';
export default /*#__PURE__*/_defineComponent({
  __name: 'GhgSolutionResults',
  props: {
    impactSolution: null,
    climateImpact: null,
    evidenceLinks: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var solutionTitle = computed(function () {
      var _props$impactSolution, _props$impactSolution2;
      return ((_props$impactSolution = props.impactSolution) === null || _props$impactSolution === void 0 ? void 0 : (_props$impactSolution2 = _props$impactSolution.concept) === null || _props$impactSolution2 === void 0 ? void 0 : _props$impactSolution2.label) || 'Solution';
    });
    var solutionDescription = computed(function () {
      var _props$impactSolution3;
      return ((_props$impactSolution3 = props.impactSolution) === null || _props$impactSolution3 === void 0 ? void 0 : _props$impactSolution3.solutionDescription) || '';
    });
    var ghgMetricAssignment = computed(function () {
      return ghgSolutionMetricAssignment(props.impactSolution, props.climateImpact);
    });
    var unitPill = computed(function () {
      var _ghgMetricAssignment$;
      var unit = (_ghgMetricAssignment$ = ghgMetricAssignment.value) === null || _ghgMetricAssignment$ === void 0 ? void 0 : _ghgMetricAssignment$.unitName;
      return unit || String(proxy.$t('unitTonnes'));
    });
    var aggregationPill = computed(function () {
      var _ghgMetricAssignment$2;
      var type = (_ghgMetricAssignment$2 = ghgMetricAssignment.value) === null || _ghgMetricAssignment$2 === void 0 ? void 0 : _ghgMetricAssignment$2.customTargetCalculationType;
      if (!type) return null;
      var keyMap = {
        SUM: 'aggregationSum',
        AVG: 'aggregationAverage',
        AVERAGE: 'aggregationAverage',
        MOST_RECENT: 'aggregationMostRecent'
      };
      var key = keyMap[String(type).toUpperCase()] || null;
      return key ? String(proxy.$t(key)) : String(type);
    });
    var reductionPledge = computed(function () {
      var _props$impactSolution4;
      var ghg = (_props$impactSolution4 = props.impactSolution) === null || _props$impactSolution4 === void 0 ? void 0 : _props$impactSolution4.ghgSavingPotential;
      if (!(ghg !== null && ghg !== void 0 && ghg.comparativeUnit)) return null;
      var percentage = roundValue(ghg.specificReductionAsPercentage);
      var reduction = roundValue(ghg.specificReductionPerUnit);
      var unit = formatComparativeUnitForPledge(ghg.comparativeUnit);
      if (!unit || !percentage && !reduction) return null;
      return String(proxy.$t('reductionPledge', {
        percentage: percentage,
        reduction: reduction,
        unit: unit
      }));
    });
    var showExpandables = computed(function () {
      var _props$impactSolution5;
      return !!((_props$impactSolution5 = props.impactSolution) !== null && _props$impactSolution5 !== void 0 && _props$impactSolution5.ghgSavingPotential);
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      solutionTitle: solutionTitle,
      solutionDescription: solutionDescription,
      ghgMetricAssignment: ghgMetricAssignment,
      unitPill: unitPill,
      aggregationPill: aggregationPill,
      reductionPledge: reductionPledge,
      showExpandables: showExpandables
    };
  }
});